export default __webpack_public_path__ + "static/media/banner12.96bff9b3.png";